import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/contexts/AuthContext';
import LoadingSpinner from '@/shared/ui/feedback/LoadingSpinner';

interface RedirectIfAuthProps {
  children: React.ReactNode;
}

const RedirectIfAuth: React.FC<RedirectIfAuthProps> = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (isAuthenticated) {
    // If the user is an admin, redirect to the dashboard or intended page
    if (user?.roles.includes('admin')) {
      const from = location.state?.from?.pathname || '/dashboard';
      return <Navigate to={from} replace />;
    }
    // If the user is not an admin, redirect to the public results page
    return <Navigate to="/results" replace />;
  }

  return <>{children}</>;
};

export default RedirectIfAuth;
